import { render, staticRenderFns } from "./YonaEditDialog.vue?vue&type=template&id=f2ee7c42&scoped=true&"
import script from "./YonaEditDialog.vue?vue&type=script&lang=js&"
export * from "./YonaEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./YonaEditDialog.vue?vue&type=style&index=0&id=f2ee7c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ee7c42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VEditDialog,VSpacer,VTextField})
